var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import Signals from '../../signals/Signals';
import updateServiceSchema from '../../requests/service/updateServiceSchema';
/**
 *
 */
var UpdateServiceSchemaCommand = /** @class */ (function (_super) {
    __extends(UpdateServiceSchemaCommand, _super);
    function UpdateServiceSchemaCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param serviceSchema ServiceSchemaModel
     * @param organisationId string
     * @param intl
     * @return {*}
     */
    UpdateServiceSchemaCommand.prototype.execute = function (serviceSchema, organisationId, intl) {
        this.intl = intl;
        this.serviceSchema = serviceSchema;
        var promise = updateServiceSchema(serviceSchema, organisationId);
        promise.then(this.then);
        return promise;
    };
    /**
     *
     * @param response
     */
    UpdateServiceSchemaCommand.prototype.then = function (response) {
        Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'notification.service.schema.edited' }, Object(this.serviceSchema)), 'dark', true);
    };
    return UpdateServiceSchemaCommand;
}(Command));
export default UpdateServiceSchemaCommand;
